"use client";

import { useIsSignedIn } from "@/components/auth/useIsSignedIn";

// Step 6.6: this component is now a presentational "+" button. The parent
// (ProductCard) owns the QuickAddPopover state and the actual cart write.
// Pre-Step-6.6 it did the direct add itself; that path is gone.
export function QuickAddButton({
  ariaLabel,
  onClick,
  soldOut = false,
}: {
  ariaLabel: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  // #452: whole variety sold out -> disabled + greyed, cannot open the popover.
  soldOut?: boolean;
}) {
  const authState = useIsSignedIn();
  if (authState !== "authed") return null;

  return (
    <button
      type="button"
      data-testid="quick-add-button"
      data-sold-out={soldOut ? "true" : undefined}
      disabled={soldOut}
      aria-label={soldOut ? "Sold out" : ariaLabel}
      onClick={onClick}
      className={
        "absolute right-3 top-3 z-[2] inline-flex h-9 w-9 items-center justify-center rounded-full shadow-lg transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white " +
        (soldOut
          ? "cursor-not-allowed bg-zinc-400 text-white"
          : "bg-brand-teal text-white hover:bg-brand-teal/90")
      }
    >
      <span aria-hidden="true" className="text-2xl font-light leading-none">
        {soldOut ? "×" : "+"}
      </span>
    </button>
  );
}
